import AvatarIcon from "assets/icons/avatar.svg?react";
import EmailIcon from "assets/icons/email.svg?react";

import styles from "./TeachersAndCoaches.module.css";
import StaffDisplay from "../StaffDisplay";

const TeachersAndCoaches = ({ teachers, error, isLoading }) => {
    return (
        <div
            className={styles.teachersAndCoaches}
            data-testid="teachers-and-coaches"
        >
            <h1 className={styles.teachersAndCoachesTitle}>
                Teachers and Learning Coaches
            </h1>
            <p>
                We are looking forward to meeting with you! If you need academic
                help, a Learning Coach meeting, or simply want to say hi, find
                the person below you would like to meet.
            </p>
            {isLoading && <p>Loading...</p>}
            {error && <p>Error: {error}</p>}
            {teachers?.map((teacher, index) => (
                <StaffDisplay
                    key={index}
                    name={teacher.name}
                    role={teacher.supportType}
                    email={teacher.emailAddress}
                    bio={teacher.bio}
                    avatar={teacher.avatarUrl}
                    canvasUserId={teacher.canvasUserId}
                    bookMeeting
                    underline
                />
            ))}
        </div>
    );
};

export default TeachersAndCoaches;
